import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: tc.textColor,
                    usePointStyle: true,
                    pointStyleWidth: 20
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let value = context.dataset.data[context.dataIndex];
                        let date = context.chart.data.labels[context.dataIndex];
                        let newlabel = "";
                        if (context.dataset.label.indexOf("Bezug") != -1)
                            newlabel += 'Bezug: ' + Math.round((value / 100) * 100) + ' kWh (' + date + ')';
                        else newlabel += 'Ertrag: ' + Math.round((value / 100) * 100) + ' kWh (' + date + ')';

                        return [newlabel]
                    }
                }
            },
            datalabels: {
                display: true,
                anchor: 'end',
                align: 'top',
                color: tc.datalabelColor,
                formatter: function (value) {
                    return Math.round(value / 100);
                },
                font: {
                    weight: 'bold'
                }
            }
        },
        scales: {
            x: {
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 45,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Monat',
                    color: tc.textColor
                }
            },
            y: {
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'kWh/Monat',
                    color: tc.textColor
                }
            }
        }
    };
};
